import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// attach token from localStorage as fallback (for environments where cookies are cross-site blocked)
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("icos_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const ROLE_LABELS = {
  admin: "Administrator",
  executive: "Executive",
  programme_manager: "Programme Manager",
  government: "Government",
  partner: "Partner Org",
  case_worker: "Case Worker",
  volunteer: "Volunteer",
  donor: "Donor",
  community: "Community",
};

export const ALL_ROLES = Object.keys(ROLE_LABELS);
